import type { InjectionKey } from 'vue';

export const EmbedKey: InjectionKey<string> = Symbol('embed');
